import { render, staticRenderFns } from "./confirmed.vue?vue&type=template&id=509ffa14&scoped=true&"
import script from "./confirmed.vue?vue&type=script&lang=js&"
export * from "./confirmed.vue?vue&type=script&lang=js&"
import style0 from "./confirmed.vue?vue&type=style&index=0&id=509ffa14&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509ffa14",
  null
  
)

export default component.exports